import React from 'react'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
	const navigate = useNavigate()

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				// backgroundColor: '#f0f4f8',
				fontFamily: 'Arial, sans-serif',
			}}
		>
			<svg width='200' height='200' viewBox='0 0 200 200' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ marginBottom: '2rem' }}>
				<circle cx='100' cy='100' r='96' stroke='red' strokeWidth='8' />
				<path d='M60 60L140 140M140 60L60 140' stroke='red' strokeWidth='8' strokeLinecap='round' />
			</svg>
			<h1
				style={{
					fontSize: '3rem',
					color: 'red', // Change to red
					marginBottom: '1rem',
					textAlign: 'center',
				}}
			>
				404 - Page Not Found
			</h1>
			<p
				style={{
					fontSize: '1.25rem',
					color: '#4b5563',
					marginBottom: '2rem',
					textAlign: 'center',
					maxWidth: '80%',
				}}
			>
				Oops! It seems like you've ventured into uncharted territory. The page you're looking for might have been moved, deleted, or never
				existed.
			</p>
			<button
				onClick={() => navigate('/')}
				style={{
					backgroundColor: '#3b82f6',
					color: 'white',
					border: 'none',
					padding: '0.75rem 1.5rem',
					fontSize: '1rem',
					borderRadius: '0.375rem',
					cursor: 'pointer',
					transition: 'background-color 0.3s ease',
				}}
				onMouseEnter={(e) => (e.target.style.backgroundColor = '#2563eb')}
				onMouseLeave={(e) => (e.target.style.backgroundColor = '#3b82f6')}
			>
				Return to Home
			</button>
		</div>
	)
}

export default NotFound
